import moment from 'moment'
import { BaseProgram } from 'redux/employeePlatform/employeePlatformTypes'
import type { BudgetCycle } from 'redux/programs/programsTypes'

type TimingUnit = 'hour' | 'hours' | 'day' | 'days'

export const isRolloverFlexProgram = (
  program: Pick<BaseProgram, 'type' | 'rolloverBudget'>
): boolean => program.type === 'FLEX' && !!program.rolloverBudget

export const getFlexBudgetCycle = (
  program: Pick<BaseProgram, 'budgetCycle' | 'cycleStart' | 'cycleEnd'>
): BudgetCycle => {
  if (program.budgetCycle) {
    return program.budgetCycle
  }
  const daysDiff = moment(program.cycleEnd).diff(moment(program.cycleStart), 'days')
  return daysDiff <= 1 ? 'DAILY' : 'MONTHLY'
}

export const getFlexCycleTiming = (
  cycleType: BudgetCycle,
  cycleEnd: string
): { amount: number; unit: TimingUnit } => {
  if (cycleType === 'DAILY') {
    const hours = Math.max(
      0,
      Math.floor(moment(cycleEnd).diff(moment(), 'hours', true))
    )
    return { amount: hours, unit: hours === 1 ? 'hour' : 'hours' }
  }

  const days = Math.max(0, moment(cycleEnd).diff(moment(), 'days'))
  return { amount: days, unit: days === 1 ? 'day' : 'days' }
}

export const getFlexCycleEndLabel = (
  cycleType: BudgetCycle,
  cycleEnd: string,
  options?: {
    isRollover?: boolean
    topUpBudget?: number
    formatAmount?: (amount: number) => string
  }
): string => {
  const { amount, unit } = getFlexCycleTiming(cycleType, cycleEnd)

  if (
    options?.isRollover &&
    options.topUpBudget != null &&
    options.formatAmount
  ) {
    return `Next top-up ${options.formatAmount(options.topUpBudget)} in ${amount} ${unit}`
  }

  return `Resets in ${amount} ${unit}`
}
